export default {
  Solicitado: 1,
  AceitoPeloMotorista: 2,
  AceitoPelaOrganizacao: 3,
  FinalizadoPeloMotorista: 4,
  FinalizadoPelaOrganizacao: 5,
  RejeitadoPeloMotorista: 6,
  RejeitadoPelaOrganizacao: 7,
  CanceladoPeloMotorista: 8,
  CanceladoPelaOrganizacao: 9,
  CanceladoPeloCliente: 10,
  CanceladoPorTempoExcedido: 11,
  AceitoPeloAdm: 12,
  AceitoPeloFuncionarioUpgas: 13,
  CanceladoPeloAdm: 14,
  CanceladoPeloFuncionarioUpgas: 15,
  RejeitadoPeloAdm: 16,
  RejeitadoPeloFuncionarioUpgas: 17,
  FinalizadoPeloAdm: 18,
  FinalizadoPeloFuncionarioUpgas:19,
  FinalizadoPeloCliente:20

}
